import { Breadcrumb, Button, Card, Col, Flex, Row, Space } from "antd";
import FormItem from "antd/es/form/FormItem";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useTranslation } from "react-i18next";
import { ReactComponent as DownloadIcon } from "../../../../assets/icon/downloadIcon.svg";
import TableAntd from "components/elements/Table";
import ReportStatus from "../ReportStatus";
import EmployeeWorkInWorkInTable from "components/table/EmployeeWorkInWorkInTable";
import WorkTimeWorkinModal from "../reportModal/WorkTimeWorkinModal";

const WorkTimeReportComponent = ({
    showReport,
    isModalOpen = false,
    handleSearch = () => { },
    getTable = () => { },
    showModal = () => { },
    setIsModalOpen = () => { }
}) => {
    const { t, i18n } = useTranslation();

    return (
        <MainLayout>
            <WorkTimeWorkinModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
            <Space direction="vertical" size={24} style={{ width: "100%" }}>
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("report.header") },
                        { title: t("working_time_group.header") },
                        { title: t("work_in_report.header") }
                    ]} />
                    <h2>{t("work_in_report.header")}</h2>
                </Flex>

                <FormAntd
                    onFinish={handleSearch}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical gap={16}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t("name-surname")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>

                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="workingTimeDate"
                                                        type="range"
                                                        label={t('start-date-to-end-date')}
                                                        // allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('start-date-to-end-date')}
                                                        size="large"
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="year"
                                                        dateFormat={"YYYY"}
                                                        picker="year"
                                                        label={t('translation.year')}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px", marginTop: "24px" }}>
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>

                                    {showReport && (
                                        <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                            <Flex justify="end">
                                                <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                    <Flex gap={8}>
                                                        <DownloadIcon />
                                                        <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                    </Flex>
                                                </Button>
                                            </Flex>
                                            <Card style={{
                                                backgroundColor: "white",
                                                width: "100%",
                                                border: "1px solid #EAECF0",
                                            }}>
                                                <Space direction="vertical" size={8} style={{ width: "100%" }}>
                                                    <span style={{ fontSize: "1vw", fontWeight: "bold" }}>{t('work_in_report.header')}</span>
                                                    {getTable()}
                                                </Space>
                                            </Card>
                                        </Space>
                                    )}
                                </>
                            )
                        }}
                    </FormItem>
                </FormAntd>
            </Space>
        </MainLayout>
    )
}

export default WorkTimeReportComponent;